<template>
  <vs-card>
    <div class="vx-row p-5">
      <div class="vx-col w-full px-8">
        <form method="POST" @submit.prevent="save_changes">
          <div class="vx-row">
            <!-- Title -->
            <div class="vx-col w-1/2 mb-2">
              <vs-input
                icon-pack="feather"
                class="w-full"
                v-validate="'required|exclude_special_char'"
                v-model="form.title"
                label="Title *"
                placeholder="Satgur Prasaadi"
                name="Title"
                id="book-title"
              />
              <span class="text-danger text-sm" v-show="errors.has('Title')">{{ errors.first('Title') }}</span>
            </div>

            <!-- Bani of -->
            <div class="vx-col w-1/2 mb-2">
              <label class="vs-input--label">Bani of *</label>
              <select-2
                class="w-full category-input"
                name="Bani of"
                placeholder="Select Writer"
                :value="form.written_by"
                @input="(item) => (form.written_by = item && item.value)"
                autocomplete
                :ssr="true"
                :multiple="true"
                :clearable="!!form.written_by.length"
                v-validate="'required'"
                action="creator/get"
                data-vv-as="Bani of"
              />
              <span class="text-danger text-sm" v-show="errors.has('Bani of')">{{ errors.first('Bani of') }}</span>
            </div>

            <!-- Day Time -->
            <div class="vx-col w-1/2 mb-2">
              <label class="vs-input--label">Day Time*</label>
              <select-2
                class="w-full"
                name="day_time"
                placeholder="Select Day Time"
                :options="MANTRA_DAY_TIME"
                v-validate="'required'"
                autocomplete
                :ssr="true"
                :clearable="!!form.day_time.length"
                :multiple="true"
                :value="form.day_time"
                data-vv-as="Day Time"
                @input="(item) => (form.day_time = item && item.value)"
              />
              <span class="text-danger text-sm" v-show="errors.has(`day_time`)">{{ errors.first(`day_time`) }}</span>
            </div>

            <!-- Structure Type -->
            <div class="vx-col w-1/4 mb-2" v-if="!$route.params.id">
              <label class="vs-input--label">Structure Type *</label>
              <select-2
                class="w-full"
                :name="'structure_type'"
                placeholder="Select Structure Type"
                v-validate="'required'"
                :options="STRUCTURE_TYPES"
                autocomplete
                :ssr="true"
                :multiple="false"
                :value="form.structure_type"
                data-vv-as="Structure Type"
                @input="(item) => (form.structure_type = item && item.value)"
              />
              <span class="text-danger text-sm" v-show="errors.has(`structure_type`)">{{ errors.first(`structure_type`) }}</span>
            </div>

            <!-- Section Type -->
            <div class="vx-col w-1/4 mb-2">
              <label class="vs-input--label">Section Type *</label>
              <select-2
                class="w-full"
                :name="'section_type'"
                placeholder="Select Section Type"
                v-validate="'required'"
                :options="SECTION_TYPES"
                autocomplete
                :ssr="true"
                :multiple="false"
                :value="form.section_type"
                data-vv-as="Section Type"
                @input="(item) => (form.section_type = item && item.value)"
              />
              <span class="text-danger text-sm" v-show="errors.has(`section_type`)">{{ errors.first(`section_type`) }}</span>
            </div>

            <!-- About -->
            <div class="vx-col w-full mb-2 block">
              <label class="vs-input--label block" for="About">About *</label>
              <vs-textarea
                placeholder="Satgur Prasad is a famous Punjabi word bani of Bhai Gurdas Ji. In this word, the message of staying in the shelter of Satguru and connecting with his visions has been given."
                class="w-full input mb-0"
                id="about"
                v-validate="'required|exclude_special_char'"
                name="about"
                v-model="form.about"
                :rows="6"
                data-vv-as="About"
              />
              <span class="text-danger text-sm" v-show="errors.has('about')">{{ errors.first('about') }}</span>
            </div>

            <!-- Meaning -->
            <div class="vx-col w-full mb-2 block">
              <label class="vs-input--label block" for="Meaning">What Dose Mean *</label>
              <vs-textarea
                placeholder="Provide the meaning of the book here."
                class="w-full input mb-0"
                id="meaning"
                v-validate="'required|exclude_special_char'"
                name="meaning"
                v-model="form.meaning"
                :rows="6"
                data-vv-as="Meaning"
              />
              <span class="text-danger text-sm" v-show="errors.has('meaning')">{{ errors.first('meaning') }}</span>
            </div>

            <vs-divider></vs-divider>

            <!-- Audio -->
            <div class="vx-col w-full cursor-pointer mb-2">
              <label class="vs-input--label block">Audio</label>
              <input type="file" v-validate="'ext:mp3,wav'" class="file-upload text-lg rounded w-full" name="audio" ref="files" accept=".mp3,.wav" @change="handleAudioUpload" data-vv-as="Audio" />
              <span class="text-danger text-sm" v-show="errors.has('audio')">{{ errors.first('audio') }}</span>
            </div>
            <div class="mt-2 ml-4 w-full">
              <div class="relative" v-if="preview_audio">
                <audio ref="audioPlayer" :src="preview_audio" controls></audio>
              </div>
            </div>

            <vs-divider></vs-divider>

            <!-- Transcript -->
            <div class="vx-col w-full cursor-pointer mb-2">
              <div class="flex items-center mb-2">
                <label class="vs-input--label block">Transcript</label>

                <vx-tooltip :text="'Download Sample Transcript File'">
                  <vs-button @click="downloadSampleTranscript" color="success" type="gradient" icon-pack="feather" icon="icon-download" class="ml-2 small-icon-button"></vs-button>
                </vx-tooltip>
              </div>
              <input type="file" class="file-upload text-lg rounded w-full" name="transcript" accept=".json" v-validate="'ext:json'" @change="handleTranscriptUpload" data-vv-as="Transcript" />
              <span class="text-danger text-sm" v-show="errors.has('transcript')">{{ errors.first('transcript') }}</span>
            </div>

            <!-- View Transcript Button -->
            <div class="mt-2 ml-4 w-4/12" v-if="preview_transcript && preview_transcript.results">
              <vs-button color="primary" @click="toggleTranscriptModal">View Transcript</vs-button>
            </div>

            <vs-divider></vs-divider>

            <!-- Image -->
            <!-- <div class="vx-col w-1/2 cursor-pointer">
                            <label class="vs-input--label block">Image *</label>
                            <input type="file" class="rounded text-lg file-upload w-full" name="image" ref="files"
                                accept=".jpg, .png , .jpeg" @change="handleFileUpload"
                                v-validate="imagevalidationRule"
                                data-vv-as="Image" />
                            <span class="text-danger text-sm" v-show="errors.has('image')">{{ errors.first('image')
                                }}</span>
                            <div class="mt-5">
                                <div class="relative" v-if="preview_image">
                                    <div class="h-64 w-64 mt-5 rounded-lg overflow-hidden">
                                        <img height="200px" width="250px" :src="preview_image" alt="Image Preview"
                                            class="object-fit" />
                                    </div>
                                </div>
                            </div>
                        </div> -->
          </div>

          <!-- Save & Reset Button -->
          <div class="vx-row pt-5 px-5 text-center">
            <div class="vx-col w-full">
              <div class="items-center">
                <vs-button class="mr-2 vs-con-loading__container" id="book" @click="save_changes"> {{ $route.params.id ? 'Update' : 'Add' }}</vs-button>
                <vs-button color="danger" class="text-left" @click="navigateList">Cancel</vs-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- <vs-popup title="Image Cropper" name="Image" :active.sync="IsOpenImageCrop" class="image-cropper" style="z-index: 55000">
      <div class="text-center flex justify-center w-full h-full">
        <div class="modal__content w-full h-full">
          <div class="modal-body w-full h-full">
            <div class="modal-form w-full h-full">
              <div class="w-full h-full max-h-450">
                <cropper
                  ref="cropper"
                  name="Image"
                  class="cropper-image"
                  :src="this.crop_image.src"
                  :stencil-props="{
                    aspectRatio: 12 / 12
                  }"
                />
              </div>
              <div class="button-wrapper mt-3">
                <vs-button type="" @click="cropImage()" class="text-primary border border-solid border-primary">Crop Image</vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-popup> -->

    <!-- Transcript Preview Modal -->
    <vs-popup title="Transcript Preview" :active.sync="isTranscriptModalOpen" class="text-left">
      <div class="p-4">
        <h3 class="text-lg font-semibold mb-4 text-gray-800">Transcript Details</h3>
        <div class="max-h-96 overflow-y-auto border rounded-md p-4 bg-gray-100">
          <ul v-if="preview_transcript && preview_transcript.results" class="space-y-4">
            <li v-for="(item, index) in preview_transcript.results" :key="index" class="p-4 bg-white rounded-md shadow-md">
              <div class="mt-1 text-sm text-gray-500"><strong class="font-semibold">Transcript:</strong> {{ item.transcript }}</div>
              <div class="mt-1 text-sm text-gray-500"><strong class="font-semibold">Start Time:</strong> {{ item.startTime }}</div>
              <div class="mt-1 text-sm text-gray-500"><strong class="font-semibold">End Time:</strong> {{ item.endTime }}</div>
            </li>
          </ul>
        </div>
      </div>
    </vs-popup>
  </vs-card>
</template>

<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { mapActions, mapState } from 'vuex'

export default {
  /** Page Name */
  name: 'AddUpdate',

  /** components */
  components: {
    Select2,
    Cropper
  },

  /** data */
  data() {
    return {
      MANTRA_DAY_TIME: [],
      creators: [],
      breadcrumb: [],
      form: {
        title: null,
        meaning: null,
        written_by: [],
        about: '',
        image: null,
        day_time: [],
        transcript: null,
        audio: null,
        structure_type: null,
        section_type: null
      },
      STRUCTURE_TYPES: [
        {
          value: 'Type 1',
          label: 'Type 1 (Slock & Pauri -> Pankti)'
        },
        {
          value: 'Type 2',
          label: 'Type 2 (Ashtapadi -> Slock & Pauri -> Pankti)'
        },
        {
          value: 'Type 3',
          label: 'Type 3 (Headers -> Slock & Pauri -> Pankti)'
        },
        {
          value: 'Type 4',
          label: 'Type 4 (Solo Reading -> Only Pankti)'
        }
      ],
      SECTION_TYPES: [
        {
          value: 'Nitnem',
          label: 'Nitnem'
        },
        {
          value: 'More Banis',
          label: 'More Banis'
        },
        {
          value: 'More Scriptures',
          label: 'More Scriptures'
        }
      ],
      preview_audio: null,
      preview_transcript: null,
      isTranscriptModalOpen: false // New data property to control the modal visibility
      // preview_image: null,
      // crop_image: {
      //   src: '',
      //   type: '',
      //   isRound: true
      // },
      // IsOpenImageCrop: false
    }
  },

  /** computed */
  computed: {
    ...mapState('book', ['createLoading']),
    validateForm() {
      return !this.errors.any()
    }
    // imagevalidationRule() {
    //   return !this.$route.params.id ? 'required' : ''
    // }
  },

  /** created */
  async created() {
    if (this.$route.params.id) {
      await this.$store.dispatch('book/show', this.$route.params.id).then(async (res) => {
        const data = res.data.data

        /** breadcrumb implement  */
        this.breadcrumb = [
          { title: 'Dashboard', url: '/dashboard' },
          { title: 'Book', url: '/book/list' },
          { title: `Edit ${data.title}`, active: true }
        ]

        /* form variable */
        this.form.title = data.title
        this.form.written_by = data.written_by ? data.written_by : []
        this.form.about = data.about
        this.form.day_time = data.day_time ? data.day_time : null
        this.form.meaning = data.meaning ? data.meaning : null
        this.preview_audio = data.audio ? data.audio : null
        this.form.section_type = data.section_type ? data.section_type : null

        if (data.transcript) {
          try {
            const response = await fetch(data.transcript)
            const jsonData = await response.json()
            this.preview_transcript = jsonData
          } catch (error) {
            console.error('Error fetching transcript JSON:', error)
            this.preview_transcript = null
          }
        } else {
          this.preview_transcript = null
        }

        // this.preview_image = data.image ? data.image : null;
      })
    }
    const { day_time } = await this.getPreDefinedValues()
    this.MANTRA_DAY_TIME = day_time.map((value) => {
      return {
        value,
        label: value
      }
    })

    /* -------------------------------------------------------------------------- */
    /*                              Creators API Call                             */
    /* -------------------------------------------------------------------------- */
    const { data } = await this.getDropdownCreators()
    this.creators = data.results.map((value) => {
      return {
        value: value._id,
        label: value.name
      }
    })
  },

  /** methods */
  methods: {
    ...mapActions('book', {
      create: 'create',
      update: 'update'
    }),
    ...mapActions('common', {
      getPreDefinedValues: 'getPreDefinedValues',
      getDropdownCreators: 'getDropdownCreators'
    }),
    downloadSampleTranscript() {
      const url = 'https://devsangatapp.s3.ap-south-1.amazonaws.com/general/dummy-2-sentance-timestamping.json'

      // Fetch the file from the server as a Blob
      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
          return response.blob() // Convert response to a Blob
        })
        .then((blob) => {
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob) // Create a link to the Blob
          link.download = 'sample-transcript.json' // Specify the filename for download
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click() // Programmatically trigger the click to download

          // Clean up by revoking the Object URL and removing the link element
          URL.revokeObjectURL(link.href)
          document.body.removeChild(link)
        })
        .catch((error) => console.error('Download failed:', error))
    },
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      // if (!this.$route.params.id && !this.form.image) {
      //   this.$vs.notify({
      //     title: 'Error',
      //     text: 'Image Is Required!',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     position: 'top-center',
      //     time: 5000,
      //     color: 'primary'
      //   });
      //   return false;
      // }
      try {
        let response
        const data = new FormData()
        for (const key in this.form) {
          if (this.form[key] != null) {
            if (typeof this.form[key] === 'object' && !['image', 'transcript', 'audio'].includes(key)) {
              this.form[key].map((item) => {
                data.append(`${key  }[]`, item)
              })
            } else {
              data.append(key, this.form[key])
            }
          }
        }
        if (this.$route.params.id) {
          delete data.structure_type
          response = await this.update({
            id: this.$route.params.id,
            data
          })
        } else {
          response = await this.create(data)
        }
        this.$router.push({
          name: 'book-list'
        })
        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    handleAudioUpload(e) {
      const file = e.target.files[0]

      // Check if a file is selected
      if (!file) {
        this.$vs.notify({
          title: 'Error',
          text: 'No file selected',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
      if (this.form.audio && this.form.audio.src) {
        URL.revokeObjectURL(this.form.audio.src)
      }
      // 2. Create the audio link to the file to optimize performance:
      this.preview_audio = URL.createObjectURL(file)
      this.form.audio = file
    },

    toggleTranscriptModal() {
      this.isTranscriptModalOpen = !this.isTranscriptModalOpen // Toggle modal visibility
    },
    handleTranscriptUpload(e) {
      const file = e.target.files[0]

      // Check if a file is selected
      if (!file) {
        this.$vs.notify({
          title: 'Error',
          text: 'No file selected',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      // Ensure it's a JSON file
      if (file.type !== 'application/json') {
        this.$vs.notify({
          title: 'Error',
          text: 'Invalid file type, please upload a JSON file',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      // Read the file content
      const reader = new FileReader()
      reader.onload = (event) => {
        try {
          const jsonData = JSON.parse(event.target.result)
          // Validate the structure of the JSON data
          if (this.validateJsonFormat(jsonData)) {
            // Assign the file to form.transcript and preview_transcript if valid
            this.form.transcript = file
            this.preview_transcript = jsonData // Store the parsed JSON data for preview
          } else {
            this.$vs.notify({
              title: 'Error',
              text: 'Invalid JSON format. Please upload a valid format.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              position: 'top-center',
              time: 5000,
              color: 'primary'
            })
          }
        } catch (err) {
          // If parsing fails
          this.$vs.notify({
            title: 'Error',
            text: 'Invalid JSON content',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        }
      }

      reader.readAsText(file)
    },

    validateJsonFormat(jsonData) {
      // Check if "results" is an array
      if (!jsonData.results || !Array.isArray(jsonData.results)) {
        return false
      }
      // Validate each item in the results array
      for (const item of jsonData.results) {
        if (typeof item.transcript !== 'string' || typeof item.startTime !== 'number' || typeof item.endTime !== 'number') {
          return false
        }
        // Optional: Add more validation rules if needed
      }
      return true
    },

    /** navigate to list */
    navigateList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.$router.push({ name: 'book-list' })
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    }

    /** file upload  */
    // handleFileUpload(e) {
    //   const file = e.target.files[0];

    //   // Check if a file is selected
    //   if (!file) {
    //     this.$vs.notify({
    //       title: 'Error',
    //       text: 'No file selected',
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       position: 'top-center',
    //       time: 5000,
    //       color: 'primary'
    //     });
    //     return;
    //   }
    //   const blob = URL.createObjectURL(file);
    //   this.crop_image = {
    //     src: blob,
    //     type: file.type
    //   };
    // e.target.value = ''
    //   this.IsOpenImageCrop = true;
    // },
    // cropImage() {
    //   const result = this.$refs.cropper.getResult();
    //   if (result.canvas == undefined) {
    //     this.$vs.notify({
    //       title: 'Error',
    //       text: 'Please Select Image',
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       position: 'top-center',
    //       time: 5000,
    //       color: 'primary'
    //     });
    //     return;
    //   }
    //   const resultTest = result.canvas.toDataURL(this.crop_image.type);
    //   const base64Image = resultTest.replace(`data:${this.crop_image.type};base64,`, '');
    //   this.b64toBlob(base64Image, this.crop_image.type);

    //   this.IsOpenImageCrop = false;
    // },
    // b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    //   const byteCharacters = window.atob(b64Data);
    //   const byteArrays = [];

    //   for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    //     const slice = byteCharacters.slice(offset, offset + sliceSize);

    //     const byteNumbers = new Array(slice.length);
    //     for (let i = 0; i < slice.length; i++) {
    //       byteNumbers[i] = slice.charCodeAt(i);
    //     }

    //     const byteArray = new Uint8Array(byteNumbers);
    //     byteArrays.push(byteArray);
    //   }

    //   const blob = new File(byteArrays, 'image.jpg', {
    //     type: contentType
    //   });
    //   this.form.image = blob;
    //   this.preview_image = URL.createObjectURL(blob);
    //   return blob;
    // }
  },
  /** watch */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    }
  }
}
</script>

<style>
.cropper-image {
  height: 400px;
  background: #ddd;
}
textarea::placeholder {
  color: #b0bec5; /* Light color for the placeholder */
  font-weight: 200;
}

.category-input::placeholder {
  color: #ccc !important; /* or any other light color you prefer */
  font-weight: 1 00 !important;
}

.small-icon-button .vs-button--icon {
  font-size: 13px; /* Adjust this size as needed */
}
.small-icon-button.vs-button {
  padding: 13px !important;
}
.small-icon-button.includeIconOnly {
  width: 13px !important;
  height: 13px !important;
}
</style>
